module.exports = __webpack_public_path__ + "static/media/Position_6m.f88422cd.jpg";